<template>
	<div class="section full about">
		<div class="about-content">
			<slide-x-left-transition>
				<div v-show="showFirst" class="left">
					<img src="../assets/img/about-logo.png" alt="">
				</div>
			</slide-x-left-transition>
			<slide-x-right-transition>
				<div v-show="showFirst">
					We are a team of best-in-class marketers and are always pushing the boundaries of influencer marketing. When you work with us, expect to be impressed by a team dedicated specifically to your projects to develop a marketing strategy, consistent updates for your different businesses and a large network of high-performance and international influencers to respond in the best way to your needs and expectations.
					<br><br>
					Vuepo is an international marketing agency with offices in Dubai and the ability to conduct influence campaigns all around the world.
				</div>
			</slide-x-right-transition>
		</div>
		<fade-transition>
			<div v-show="showSecond" class="bottom">
				<div class="container">
					<div class="social">
						<router-link to="/contact"><span class="instagram"></span></router-link>
						<!-- <router-link to="/contact"><span class="facebook"></span></router-link> -->
					</div>
					<div class="author">
						<!-- <i>Manon Tanti</i>
						<br>
						&copy; Anthony Passant -->
					</div>
				</div>
			</div>
		</fade-transition>
	</div>
</template>

<script>
export default {
	data () {
		return {
			showFirst: false,
			showSecond: false,
			showThird: false,
		}
	},
	mounted () {
		setTimeout(() => {
			this.showFirst = true
		}, 200)
		setTimeout(() => {
			this.showSecond = true
		}, 400)
		setTimeout(() => {
			this.showThird = true
		}, 900)
	}
}
</script>